module.exports = __webpack_public_path__ + "static/media/cis555_report-3.b4565981.pdf";